import React, { useContext } from 'react'
import { ResultBlock, MainForm, ModalComponent, Header } from '../../components/index';
import { useTranslation } from 'react-i18next';
import { Container, Box } from '@mui/material';
import bg from '../../images/bg.png'

import './CalculatorPage.scss'
import { Context } from '../../AppContext';

const CalculatorPage = () => {
    const { t } = useTranslation()
    const { inputFields, openModal, valueFrom,
        setValueFrom,
        valueTo,
        setValueTo, codeFrom,
        setCodeFrom,
        codeTo,
        setCodeTo,
        modalTitle,
        setModalTitle } = useContext(Context)

    const totalVolume = inputFields
        .map(el => el.length * el.width * el.height)
        .map(el => Number(el))
        .reduce((total, count) => total + count
        )

    const totalKg = inputFields
        .map(el => el.weight)
        .map(el => Number(el))
        .reduce((total, count) => total + count)

    const totalPlaces = inputFields
        .map(el => el.seats)
        .map(el => Number(el))
        .reduce((total, count) => total + count)

    return (
        <Container >
            <Header />
            <div className='main__banner'>
                <div className='main__banner-text'>
                    <h1>
                        {t("cost_calculation")}
                    </h1>
                    <p>
                        {t("info.descr")}
                    </p>
                </div>
                <img src={bg} alt="bg" className="backgrounImg" />
            </div>
            <div className="content">
                {openModal &&
                    <ModalComponent
                        valueFrom={valueFrom}
                        valueTo={valueTo}
                        codeFrom={codeFrom}
                        codeTo={codeTo}
                        totalKg={totalKg}
                        totalVolume={totalVolume}
                        modalTitle={modalTitle}
                        totalPlaces={totalPlaces}
                    />}
                <div className="content__block">
                    <p className="content__block-subtitle">
                        {t("warning.attention")}
                    </p>
                    <MainForm
                        valueFrom={valueFrom}
                        valueTo={valueTo}
                        codeFrom={codeFrom}
                        setCodeFrom={setCodeFrom}
                        codeTo={codeTo}
                        setValueFrom={setValueFrom}
                        setValueTo={setValueTo}
                        setCodeTo={setCodeTo}
                        totalVolume={totalVolume}
                        totalKg={totalKg}
                        setModalTitle={setModalTitle}
                    />
                </div>
            </div>

        </Container>

    )
}

export default CalculatorPage